// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.parmCheckboxes {
    display: flex;
    align-content: center;
    align-items: center;
    height: 60px;
}*/
`, "",{"version":3,"sources":["webpack://./src/app/settings/rest/rest.overview/end.point.settings/end.point.rest/end.point.parameter.dialog/end.point.parameter.dialog.css"],"names":[],"mappings":"AAAA;;;;;EAKE","sourcesContent":["/*.parmCheckboxes {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    height: 60px;\n}*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
